import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function PWAUpdateToast() {
  const [visible, setVisible] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onNeedRefresh() {
      setNeedRefresh(true);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      setVisible(true);
    }
  }, [needRefresh]);

  if (!visible) {
    return null;
  }

  const dismiss = () => {
    setVisible(false);
    setNeedRefresh(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] w-full max-w-sm -translate-x-1/2 px-3 sm:px-0">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-app-border bg-app-surface/95 dark:bg-gray-900/95 shadow-2xl px-5 py-4">
        <p className="text-sm font-semibold text-app-text">
          Ny version tilgængelig
        </p>
        <div className="flex w-full sm:w-auto gap-2 sm:ml-auto">
          <button
            type="button"
            onClick={dismiss}
            className="flex-1 rounded-full bg-transparent px-3 py-1.5 text-xs font-semibold text-app-text-secondary hover:text-app-text transition min-h-[44px]"
          >
            Senere
          </button>
          <button
            type="button"
            onClick={() => updateServiceWorker(true)}
            className="flex-1 rounded-full bg-app-primary px-3 py-1.5 text-xs font-semibold text-white hover:opacity-90 transition min-h-[44px]"
          >
            Opdater nu
          </button>
        </div>
      </div>
    </div>
  );
}






